import {
  IAdminHoleResultsStore,
  IHoleResult
} from '../../../../../../../store/admin/holeResults/store';
import { TIFormatPrefix } from '../../../../../../../store/admin/roundFormats/store';
import { IMetaResult } from '../../../../../../../store/admin/roundResults/store';
import { IHoleResultsStore } from '../../../../../../../store/player/holeResults/store';

import { groupBy } from '../../../../../../../contrib/utils';
import { sortBy } from '../../../../../../../contrib/sortBy';
import { getResultFieldName } from '../../../ResultsTable/Utils/getResultFieldName';
import { ISkinsResults, IStateDispatchActions } from '../AssignResults.context';

export type ISetCTPResults = (
  holeResults: IAdminHoleResultsStore | IHoleResultsStore,
  roundId: number,
  considerFlight: boolean
) => void;

export const setCTPResults: IStateDispatchActions<ISetCTPResults> = (_, dispatch) => async (
  holeResults,
  roundId,
  considerFlight
) => {
  if (holeResults[roundId]) {
    const processedPrefix = `ctp${considerFlight ? 'Flight' : 'Round'}` as TIFormatPrefix;

    const participatingFieldName = getResultFieldName(
      processedPrefix,
      null,
      'Participating'
    ) as keyof IMetaResult;

    const filteredHoleResults = holeResults[roundId].filter(
      (result: IHoleResult) => result[participatingFieldName]
    );

    const sortedHoleResults: IHoleResult[] = sortBy(filteredHoleResults, 'asc', 'hole');
    const groupedHoleResults: ISkinsResults = groupBy(sortedHoleResults, 'hole');

    if (filteredHoleResults) {
      dispatch({
        type: 'setCTPResults',
        value: groupedHoleResults
      });
    }
  }
};
